// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "canvas {\n  outline: none;\n}\n\n.v-map-container {\n  width: 100%;\n  height: 100%;\n}\n\n/*# sourceMappingURL=v-mapbox.css.map */", "",{"version":3,"sources":["webpack://./node_modules/v-mapbox/dist/stdin","webpack://./node_modules/v-mapbox/dist/v-mapbox.css"],"names":[],"mappings":"AACA;EACI,aAAA;ACAJ;;ADEA;EACI,WAAA;EACA,YAAA;ACCJ;;AAEA,uCAAuC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
